/**
 * Use this mixin for strings tasks
 */
export const gdStrings = {
  methods: {
    newFormatPhone() {
      //document.getElementById("phone").addEventListener("input", function (e) {
      //var x = e.target.value
      var x = this.phone
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      //e.target.value = !x[2]
      this.phone = !x[2]
        ? x[1]
        : "(" + x[1] + ")" + x[2] + (x[3] ? "-" + x[3] : "");
      //});
    },
    formatPhone: function (prop) {
      if (!this[prop]) {
        return;
      }
      /**
       * Patterns for not valid and bogus phone numbers we're ignoring:
       * 1
       * +1
       * (555)555
       */
      // Strip leading 1 or +1
      if (this[prop].substr(0, 1) == "1") {
        this[prop] = this[prop].slice(1);
      } else if (this[prop].substr(0, 2) == "+1") {
        this[prop] = this[prop].slice(2);
      } else if (this[prop].substr(0, 2) == "(1") {
        this[prop] = this[prop].slice(2);
      } else if (this[prop].match(/\({0,1}555\){0,}(555){0,1}/)) {
        this[prop] = "";
      }
      // Strip non-numeric values except for parentheses and dashes.
      this[prop] = this[prop].replace(/[^0-9()-]/g, "");
      var c = this[prop].replace(/\D/g, "");
      var ready = c.match(/^[0-9]{10}$/) ? true : false;
      if (ready === true) {
        var formatted = "";
        var l = c.length;
        if (l >= 3) {
          formatted += "(" + c.substr(0, 3) + ")";
        }
        if (l >= 6) {
          formatted += c.substr(3, 3);
        }
        if (l >= 10) {
          formatted += "-" + c.substr(6, 4);
          this[prop] = formatted;
        }
      }
    },
  },
};
